import { EventEmitter } from '@angular/core';

export class ViewboxOption<T> {
  set selected(value: boolean) {
    this._selected = value;
    if (this._selected) {
      this.selected$.emit(value);
    }
  }

  get selected(): boolean {
    return this._selected;
  }

  private _selected?: boolean;
  description: string;
  content: string;
  option: T;
  link?: string;
  priceChange?: number;
  selected$?: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(selected: boolean, description: string, content: string, option: any, link?: string) {
    this._selected = selected;
    this.description = description;
    this.content = content;
    this.option = option;
    this.link = link;
  }
}
